import { render, staticRenderFns } from "./SendReviewEmail.vue?vue&type=template&id=ef82b658"
import script from "./SendReviewEmail.vue?vue&type=script&lang=ts"
export * from "./SendReviewEmail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports